import { PublicParams } from '@shared/utils/publicParams';
import { NormalCode } from './../../../shared/utils/normalCode';
import { SettingsService, _HttpClient } from '@delon/theme';
import { Component, OnDestroy, Inject, Optional, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NzMessageService, NzModalService } from 'ng-zorro-antd';
import { SocialService, ITokenService, DA_SERVICE_TOKEN } from '@delon/auth';
import { ReuseTabService } from '@delon/abc';
import { StartupService } from '@core';
// 引入url文件
import { loginUrls } from '../../../shared/urls/loginUrls';
import { UserDetailResp } from '@shared/utils/userDetailResp';
import { CacheService } from '@delon/cache';
import * as publicMethods from './../../../shared/utils/publicMethods';
// tslint:disable-next-line: no-duplicate-imports
import { generateFormData } from './../../../shared/utils/publicMethods';

@Component({
    selector: 'passport-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less'],
    providers: [SocialService],
})
export class UserLoginComponent implements OnDestroy, OnInit {
    validateParam = {
      captcha: ''
    }
    captchaUrl = '';
    userKey = '';
    constructor(
        fb: FormBuilder,
        private router: Router,
        private settingsService: SettingsService,
        @Optional()
        @Inject(ReuseTabService)
        private reuseTabService: ReuseTabService,
        @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
        private startupSrv: StartupService,
        public http: _HttpClient,
        public msg: NzMessageService,
        private modal: NzModalService,
        public cacheService: CacheService,
    ) {
        this.form = fb.group({
            userName: [null, [Validators.required, Validators.minLength(3)]],
            password: [null, Validators.required],
            captcha: [null, Validators.required]
        });
        this.changeCaptcha();
    }
    ngOnInit(): void {

    }

    get userName() {
        return this.form.controls.userName;
    }
    get password() {
        return this.form.controls.password;
    }
    get captcha () {
      return this.form.controls.captcha;
    }
    form: FormGroup;
    error = '';

    submit() {
        this.error = '';
        this.userName.markAsDirty();
        this.userName.updateValueAndValidity();
        this.password.markAsDirty();
        this.password.updateValueAndValidity();
        this.captcha.markAsDirty();
        this.captcha.updateValueAndValidity();
        if (this.userName.invalid || this.password.invalid || this.captcha.invalid) {
            return;
        }

        // 请求登录接口
        this.http
            .post(
                loginUrls.login.url,
                generateFormData({
                    account: this.userName.value,
                    password: publicMethods.encrypt(this.password.value, PublicParams.salt),
                    loginCaptcha: this.captcha.value,
                    userKey: this.userKey
                }),
            )
            .subscribe((res: any) => {
                console.log(res);
                if (res.err_code === NormalCode.NORMAL_CODE) {
                    this.success(res.token);
                } else {
                    this.error = res.err_msg;
                }
            });
    }

    /**
     * 登录成功后的操作
     * @param token 登录后返回的token
     */
    success(token: string) {
        console.log('token is ', token);
        // 清空路由复用信息
        this.reuseTabService.clear();
        // 设置用户Token信息
        this.tokenService.set({ token });
        // 登录成功后，设置token，获取用户信息
        this.http.post(loginUrls.queryUserInfo.url, {}).subscribe((response: any) => {
            console.log(response);
            if (response.err_code === NormalCode.NORMAL_CODE) {
                // set侧边栏顶部用户信息
                this.settingsService.setUser({
                    avatar: response.avatarId,
                    name: response.name,
                    email: response.email,
                });
                // 缓存当前登录用户信息
                sessionStorage.setItem(PublicParams.cacheUserName, JSON.stringify(new UserDetailResp(response)));
                this.cacheService.set(PublicParams.cacheUserName, new UserDetailResp(response));
                this.startupSrv.load().then(() => {
                    if (response.role.includes('学生')) {
                        this.router.navigateByUrl('/student');
                    } else {
                        // 路由跳转
                        this.router.navigateByUrl('/teacher');
                    }
                    // this.cacheService.get(PublicParams.cacheUserName).subscribe((res: UserDetailResp) => {
                    //     if (!res.email || !res.phone) {
                    //         this.modal.confirm({
                    //             nzTitle: '<i>提示?</i>',
                    //             nzContent:
                    //                 '<b>系统检测到你当前账号未绑定手机，为了你的账号安全起见，请先进行手机绑定，否则将无法使用其相关功能，是否立即前往绑定？</b>',
                    //             nzOnOk: () => this.router.navigateByUrl('/account-settings'),
                    //         });
                    //     }
                    // });
                });
            } else {
                this.msg.error(response.err_msg);
            }
        });
    }

    private getBase64(img: Blob, callback: (img: string) => void): void {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result!.toString()));
        reader.readAsDataURL(img);
    }

    ngOnDestroy(): void { }

    changeCaptcha () {
      this.http.get(loginUrls.captcha.url).subscribe((res: any) => {
        console.log(res);
        this.userKey = res.key;
        this.captchaUrl = 'data:image/png;base64,' + res.imageBase64;
      }, error1 => {});
    }
}
